import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { filterClasses } from "@swivl-mono/helpers";
import { HTMLAttributes, ReactNode } from "react";

enum Outlet {
  WRAPPER = "wrapper",
  DROPDOWN = "dropdown"
}

export enum DropdownPosition {
  LEFT = "left",
  RIGHT = "right"
}

interface DropdownContainerProps extends HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  position?: DropdownPosition;
  classNames?: { [Key in Outlet]?: string };
  id?: string;
  footer?: ReactNode;
  styles?: { [Key in Outlet]?: React.CSSProperties };
  /**
   * Radix modal behavior. Defaults to Radix's own default (`true`), which locks
   * pointer events outside the menu while open. Pass `false` for lightweight
   * menus (e.g. filter chips) so the trigger stays hoverable while open.
   */
  modal?: boolean;
}

// this will likely become a replacement for the existing dropdown component

const DropdownContainer = ({
  children,
  classNames = {},
  id,
  isOpen,
  onOpenChange,
  position = DropdownPosition.LEFT,
  trigger,
  footer,
  styles = {},
  modal
}: DropdownContainerProps) => {
  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={onOpenChange} modal={modal}>
      <DropdownMenu.Trigger asChild>
        <div className={classNames.wrapper || ""} style={styles.wrapper}>
          {trigger}
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          sideOffset={4}
          align={position === DropdownPosition.LEFT ? "start" : "end"}
          collisionPadding={8}
          id={id}
          className={filterClasses(
            "z-200 flex max-h-[min(486px,calc(var(--radix-dropdown-menu-content-available-height)-16px))] w-full flex-col rounded-md bg-white shadow-[0_2px_4px_0_rgba(0,0,0,0.15),0_1px_1px_0_rgba(0,0,0,0.15)]",
            classNames.dropdown || ""
          )}
          style={styles.dropdown}
        >
          <div className={filterClasses("flex min-h-0 flex-col items-center gap-2 overflow-y-auto px-2 pt-2", footer ? "" : "pb-2")}>{children}</div>
          {footer}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export { DropdownContainer };
